import axios from 'axios';

export function barretCleanUrlsFromImgList(imgList) {
    if (!imgList || typeof imgList !== 'object') {
        return [];
    }

    return Object.keys(imgList)
        .map(key => imgList[key])
        .filter(url => typeof url === 'string' && url.indexOf('/img/') !== -1)
        .map(url => url.replace('/img/', '/barret/clean/'));
}

export function purgeOffertaImages(imgList) {
    const urls = barretCleanUrlsFromImgList(imgList);

    // Logs per purge cache offerte sito hotel (disattivati)
    // console.log(
    //     '%c[WAO purge] GET barret /clean/',
    //     'color:#06c;font-weight:bold',
    //     { count: urls.length, urls }
    // );
    // if (urls.length === 0) {
    //     console.warn(
    //         '[WAO purge] barret: nessuna URL (imgList vuoto o senza /img/)'
    //     );
    // }
    // return Promise.all(
    //     urls.map(url =>
    //         axios.get(url).then(
    //             response => {
    //                 console.log(
    //                     '%c[WAO purge] barret OK',
    //                     'color:#0a7;font-weight:bold',
    //                     { status: response.status, url }
    //                 );
    //                 return response;
    //             },
    //             error => {
    //                 console.error('[WAO purge] barret ERRORE', { url, error });
    //                 throw error;
    //             }
    //         )
    //     )
    // );

    return Promise.all(urls.map(url => axios.get(url)));
}
